import { AxiosError } from 'axios';
import { getCarrierAxiosInstance } from '../../../../common/services/axios-config';
import IBranchTableData from '../../interfaces/IBranchTableData';
import IApiError from '../../../../common/errors/interfaces/IApiError';
import ProcessingError, {
    getProcessingErrors,
    isProcessingError,
} from '../../../../common/errors/processing-error';
import CONTACT_SUPPORT_MESSAGE from '../../../../common/constants/messages';
import i18n from '../../../../lib/i18n';

const ReproveBranch = async (
    branches: IBranchTableData[],
    carrierId: string,
) => {
    const api = await getCarrierAxiosInstance();

    const response = await api
        .post(
            `v1/carriers/${carrierId}/branches:reprove`,
            branches.map(b => b.id),
        )
        .catch((error: AxiosError<IApiError>) => {
            if (isProcessingError(error)) {
                const exceptionReproveBranchNames = getProcessingErrors(
                    error,
                    branches.map(branch => ({
                        id: branch.id,
                        name: branch.corporateName,
                    })),
                );

                if (exceptionReproveBranchNames.length > 0) {
                    const branchNames = exceptionReproveBranchNames.join(', ');
                    const errorMessage = `${i18n.t('AsFilias')}: ${branchNames}, ${i18n.t('ReproveErrorMessage')}. ${i18n.t(CONTACT_SUPPORT_MESSAGE)}`;

                    throw new ProcessingError(errorMessage);
                }
            }

            throw new Error(i18n.t(CONTACT_SUPPORT_MESSAGE));
        });

    return response.data;
};

export default (() => {
    return {
        ReproveBranch,
    };
})();
